import React, { useState } from 'react';
import FirstStep from './FirstStep';
import CloudHosting from 'views/CloudHosting';
import DesignCompany from 'views/DesignCompany';
import Container from 'components/Container';
import initialStepData from './initialStepData';
import secondStepData from 'views/CloudHosting/secondStepData';
import thirdStepData from 'views/DesignCompany/thirdStepData';
import StepFivePayment from './StepFivePayment';
import Grade11Form4 from 'views/Grade11Form4';
import { WithNumbersOnly } from 'blocks/progressSteps';
import { Divider, Typography } from '@mui/material';
import Footer from 'layouts/Main/components/Footer';
import Step6Success from 'views/NotFoundCover/Step6Success';


const Logistics = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [initialState, setInitialState] = useState(initialStepData);
  const [secondState, setSecondState] = useState(secondStepData);
  const [thirdState, setThirdState] = useState(thirdStepData);

  
    const handleCurrentStep = (newStep, data) => {
      if (newStep === 2 && data) {
        setInitialState(data);
      }
      if (newStep === 3 && data) {
        setSecondState(data);
      }
      if (newStep === 4 && data) {
        setThirdState(data);
      }
      setCurrentStep(newStep);
    };

  return (
    <>
<div style={{ height: 40, backgroundColor: '#377dff', padding: '10px' }}>
        <Typography
        style={{ float: 'left' }}
        variant={'subtitle2'}
        color={'white'}
      >NPS YPR</Typography>
        <a style={{ float: 'right' }} href="/online-registration-email-login" >
          <img 
          height={20}
          width={20}
          color={'white'}
          src='https://cdn-icons-png.flaticon.com/512/25/25376.png'/>
        </a>
      </div>
      <div maxWidth={0.9}  style={{ display: 'flex' }}>
        <WithNumbersOnly currentStep={currentStep - 1} showProgressOnly />
      </div>
      <Container maxWidth={0.7} paddingTop={'0 !important'} bgcolor={'alternate.main'}>
        {currentStep === 1 && (
          <FirstStep
            handleCurrentStep={handleCurrentStep}
            initialState={initialState}
          />
        )}
        {currentStep === 2 && (
          <CloudHosting
            handleCurrentStep={handleCurrentStep}
            secondState={secondState}
          />
        )}
        {currentStep === 3 && (
          <DesignCompany
            handleCurrentStep={handleCurrentStep}
            thirdState={thirdState}
          />
        )}
        {currentStep === 4 && (
          <Grade11Form4
            initialState={initialState}
            secondState={secondState}
            thirdState={thirdState}
            handleCurrentStep={handleCurrentStep}
          />
        )}
        {currentStep === 5 && (
         <StepFivePayment 
         initialState={initialState}
         secondState={secondState}
         thirdState={thirdState}
         handleCurrentStep={handleCurrentStep}
         />
         )}
          {currentStep === 6 && (
          <Step6Success handleCurrentStep={handleCurrentStep} />
        )}
      </Container>
    
      <Container maxWidth={0.9}>
        <Footer />
      </Container>
    </>
  );
};

export default Logistics;
